export default __webpack_public_path__ + "static/media/ic_dispatches.59783fc6.svg";